import { useQuery } from '@tanstack/react-query'
import { QueryKey } from 'service/hooks/queryKeys'
import endpoint from 'service/api/products/{id}/index'
import { useAtom } from 'jotai'
import { googleCredentialAtom } from 'store/atoms'

const useGetProduct = (args: { id?: number }) => {
  const [googleCredential] = useAtom(googleCredentialAtom)
  return useQuery({
    queryKey: [QueryKey.GET_PRODUCT, args],
    queryFn: () =>
      endpoint({
        pathParams: args,
        params: { 'google-token': googleCredential?.credential }
      }),
    enabled: !!args.id
  })
}

export { useGetProduct }
